import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "cities",
        object: "city",
        header: [
            { text: "Nombre", value: "name" },
            { text: "Código postal", value: "zip_code" },
            { text: "Precio", value: "price" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
